// *******************************************************************************
// Open Impressum modal
// *******************************************************************************

attachEvent('[data-open-modal]', 'click', (ev) => {
  const targetModal = ev.target.getAttribute('data-open-modal');
  document.querySelector(`[data-modal="${targetModal}"]`).classList.add('is-open-modal');
  ev.preventDefault();
});
